import { TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { AdaptivaUrlRequiredPipe, ContentIdRequiredPipe, DisplayAuthoringPropertyPipe, FileNameRequiredPipe, InheritPipe, IsRequiredPropertyPipe, UploadAllowedPipe, VendorUrlRequiredPipe } from '@adaptiva/metadata/common';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { FileUploaderComponentModule } from '@adaptiva/widgets/file-uploader';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { OverlayComponentModule } from '@adaptiva/widgets/overlay';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { ContentOverrideForRepairPropertiesComponent } from './content-override-for-repair-properties.component';

const widgets = [
	CardComponentModule,
	ContainerComponentModule,
	TextComponentModule,
	InputComponentModule,
	ComboComponentModule,
	AuthoringPropertyLabelComponentModule,
	LabelComponentModule,
	FileUploaderComponentModule,
	OverlayComponentModule,
	ButtonComponentModule,
	ComboComponentModule
];

@NgModule({
	imports: [
		CommonModule,
		DisplayAuthoringPropertyPipe,
		IsRequiredPropertyPipe,
		InheritPipe,
		UploadAllowedPipe,
		FileNameRequiredPipe,
		ContentIdRequiredPipe,
		AdaptivaUrlRequiredPipe,
		VendorUrlRequiredPipe,
		TemplateMarkerDirectiveModule,
		...widgets
	],
	declarations: [ContentOverrideForRepairPropertiesComponent],
	exports: [ContentOverrideForRepairPropertiesComponent]
})
export class ContentOverrideForRepairPropertiesComponentModule {

}
